import { supabase } from "./supabaseClient";

async function invoke(action, payload = {}) {
  const { data, error } = await supabase.functions.invoke("admin-users", {
    body: { action, ...payload },
  });

  if (error) {
    let message = error.message;
    try {
      const ctx = await error.context.json();
      if (ctx && ctx.error) message = ctx.error;
    } catch (_) {
      // response body wasn't JSON — keep default error.message
    }
    throw new Error(message);
  }
  if (data && data.error) throw new Error(data.error);
  return data;
}

export const listUsers = () => invoke("list");
export const createUser = (email, password, role, fullName) =>
  invoke("create", { email, password, role, full_name: fullName });
export const updateUserRole = (userId, role) => invoke("update_role", { userId, role });
export const resetUserPassword = (userId, password) => invoke("reset_password", { userId, password });
export const deleteUser = (userId) => invoke("delete", { userId });

// Role akun yang sedang login — dipakai untuk menampilkan/menyembunyikan
// menu "Kelola User" di sidebar. Ini cuma UX; proteksi sebenarnya ada di
// Edge Function (memverifikasi role admin sebelum mengeksekusi apa pun).
export async function getMyProfile() {
  const { data: auth } = await supabase.auth.getUser();
  if (!auth?.user) return null;
  const { data, error } = await supabase
    .from("profiles")
    .select("id, role, full_name, email")
    .eq("id", auth.user.id)
    .single();
  if (error) return null;
  return data;
}
